import React, { useEffect, useRef } from 'react'
import Head from 'next/head'
import PropTypes from 'prop-types'
import { install } from 'resize-observer'
import NextApp from 'next/app'

import App from '@/components/App'
import { NonceContext } from '@/utils/nonce'
import { FeatureGateContext, getFeatureGatesFromHeaders } from '@/utils/featureGate'
import '@/styles/globals.scss'
import '@/utils/rollbar'
import { initializeClientHints } from '@/utils/client-events'

function MyApp({ Component, pageProps, nonce, featureGates }) {
  const nonceRef = useRef(nonce)
  const featureGatesRef = useRef(featureGates)

  useEffect(() => {
    if (nonce) {
      nonceRef.current = nonce
    }
  }, [nonce])

  useEffect(() => {
    if (featureGates) {
      featureGatesRef.current = featureGates
    }
  }, [featureGates])

  useEffect(() => {
    const boldText = 'font-weight: bold'
    const normalText = 'font-weight: normal'
    // eslint-disable-next-line no-console
    console.log(`%cWelcome to Neat!
    \n%cRelease Date: %c${process.env.releaseDate}
    \n%cTag: %c${process.env.NEXT_PUBLIC_BUILD_TAG}
    \n%cEnvironment: %c${process.env.NEXT_PUBLIC_ENV}
    \n%cCommit: %c${process.env.NEXT_PUBLIC_BUILD_COMMIT || 'not available'} `,
    boldText,
    boldText, normalText,
    boldText, normalText,
    boldText, normalText,
    boldText, normalText)
  }, [])

  useEffect(() => {
    // https://neatco.jira.com/browse/NEAT-14191
    if (!window.ResizeObserver) install()
  }, [])

  useEffect(() => {
    initializeClientHints()
  }, [])

  return (
    <NonceContext.Provider value={nonceRef.current}>
      <FeatureGateContext.Provider value={featureGatesRef.current}>
        <Head>
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <title>Neat</title>
          <link href="/favicon.ico" rel="shortcut icon" />
        </Head>
        <App layoutProps={{ ...Component.layoutProps }}>
          <Component {...pageProps} />
        </App>
      </FeatureGateContext.Provider>
    </NonceContext.Provider>
  )
}

MyApp.getInitialProps = async (
  Context,
) => {
  const props = await NextApp.getInitialProps(Context)
  const { ctx } = Context
  const nonce = ctx.req?.headers?.['x-nonce']

  return {
    ...props,
    nonce,
    featureGates: getFeatureGatesFromHeaders(ctx.req?.headers),
  }
}

MyApp.propTypes = {
  Component: PropTypes.func,
  pageProps: PropTypes.shape({}),
  featureGates: PropTypes.shape({}),
  nonce: PropTypes.string,
}

export default MyApp
